//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 14/08/2025
// Version : 1
// Description : Dialog para derivar los viajes
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import { UrlApi } from "../../services/apirest";
import {
  Button,
  Dialog,
  Box,
  Grid,
  Stack,
  Snackbar,
  TextField,
  Alert,
  Autocomplete,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import Title from "../Title";
import { logEventos } from "../../services/services";
import moment from "moment";

function Dialog_derivado(props) {
  // para abrir
  const [abrirDialogDerivar, setAbrirDialogDerivar] = useState(
    props.abrirDialogDerivar
  );

  const [datosDerivacion, setDatosDerivacion] = useState(props.row);
  const [update, setUpdate] = useState(false);

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  const [sucursales, setSucursales] = useState([]);
  const [sucursalesSeleccionadas, setSucursalesSeleccionadas] = useState(null);

  const obtenerSucursales = () => {
    fetch(UrlApi + "/sucursales/tipoPlanta")
      .then((data) => data.json())
      .then((data) => setSucursales(data));
  };
  useEffect(() => {
    obtenerSucursales();
  }, []);

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const handleClose = () => {
    setAbrirDialogDerivar(!abrirDialogDerivar);
    if (props.onClose) {
      props.onClose();
    }
  };

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const fechaHoy = moment().format("YYYY-MM-DD");

  const guardarDerivar = async (e) => {
    e.preventDefault();

    logEventos(
      "Guardar derivacion",
      "Viajes a Sucursales",
      "Se guardó derivación",
      localStorage.getItem("user")
    );

    try {
      // Marcar el viaje como derivado en viajes
      await fetch(
        `${UrlApi}/viajes_abastecimiento/${datosDerivacion.id_viaje}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ derivado: 1 }),
        }
      );

      // registro en historial
      await fetch(`${UrlApi}/viajes_abastecimiento_historial`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fecha_derivacion: fechaHoy,
          destino_derivacion: sucursalesSeleccionadas.id,
          uuid_derivado: datosDerivacion.uuid,
          usuario_derivacion: localStorage.getItem("user"),
        }),
      });

      setOpenSnack(true);
      setColorMensaje("#D4EFDF");
      setMensaje("La derivación se guardó exitosamente!");
      setUpdate(true);
    } catch (err) {
      console.log(err);
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("Error al guardar la derivación");
    }

    handleClose();
  };

  const almacenar = (e) => {
    setDatosDerivacion({
      ...datosDerivacion,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div>
      <Dialog
        open={abrirDialogDerivar}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
      >
        <Title
          titulo={`Derivar Viaje`}
          handleClose={() => {
            handleClose();
          }}
        />
        <form onSubmit={guardarDerivar} autoComplete="off">
          <Box
            border={0.5}
            borderColor={grey[300]}
            backgroundColor="#F4F6F6"
            p={2}
            py={2}
            mt={1}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} mb={2}>
                <Autocomplete
                  disableClearable
                  size="small"
                  required
                  noOptionsText={"SUCURSAL INEXISTENTE"}
                  options={sucursales || []}
                  value={sucursalesSeleccionadas}
                  autoHighlight
                  getOptionLabel={(sucursal) =>
                    sucursal.id + "-" + sucursal.nombre
                  }
                  onChange={(event, value) => setSucursalesSeleccionadas(value)}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id} - {option.nombre}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                      }}
                      focused
                      size="small"
                      placeholder="Tipee para buscar..."
                      label="Sucursales"
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Stack direction="row">
              <Grid container direction={{ xs: "column", sm: "row" }}>
                <Grid item xs={9}>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleClose}
                  >
                    No
                  </Button>
                </Grid>
                <Grid item xs={3}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="success"
                    type="submit"
                    disabled={!sucursalesSeleccionadas}
                  >
                    Si
                  </Button>
                </Grid>
              </Grid>
            </Stack>
          </Box>
        </form>
      </Dialog>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </div>
  );
}

export default Dialog_derivado;
